<app-menu>
    <div [ngClass]="{'body-light': !dark_mode.checked, 'body-dark': dark_mode.checked}" style="width: 100%">   
        <div class="container">
            <div>
                <h1 class="grid-item" style="margin-bottom: 0; text-align:center; background-color: rgb(22, 3, 3);color: #fdfdfd;">Beacon Device Details
                    <div style="text-align: right;">
                        <button matTooltip="Change Colour Scheme" id="dark_mode" (click)="dark_mode.checked = !dark_mode.checked">
                            {{dark_mode.checked ? 'Light Mode' : 'Dark Mode'}}
                        </button>
                        <input #dark_mode type="checkbox" [hidden]="true">&nbsp;&nbsp;
                        <button matTooltip="Return back to List" onclick="history.back()">
                            <i style="font-size: 15px;" class="fas fa-backward"></i>
                        </button>&nbsp;
                    </div>
                </h1>
            </div>

            <div class="loading-overlay" *ngIf="isLoading">
                <div class="loading-content">
                    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                    <p>Loading, please wait...</p>
                </div>
            </div>

            <mat-tab-group
                [ngClass]="{'title-dark': dark_mode.checked, 'title-light': !dark_mode.checked}"
                (selectedTabChange)="onTabChange($event)">

                <mat-tab label="General Info">
                    <form [formGroup]="generalInfoForm">
                        <div><br>
                            <h2 style="background-color: rgb(2, 110, 74); color: #fdfdfd; margin-left: 10px;">
                                &nbsp;<i style="font-size: 30px;" class="fa-solid fa-circle-info"></i>&nbsp;&nbsp;General Info
                            </h2>

                            <div style="display: grid; grid-template-columns: repeat(10, 250px); gap: 0px 10px;">
                                <mat-form-field class="input-container">
                                    <mat-label>Beacon ID</mat-label>
                                    <input matInput type="string" formControlName="beacon_device_uuid" hidden>
                                    <input matInput formControlName="beacon_id" readonly>
                                </mat-form-field>

                                <mat-form-field class="input-container">
                                    <mat-label>Beacon Name</mat-label>
                                    <input matInput formControlName="beacon_name" readonly>
                                </mat-form-field>

                                <mat-form-field class="input-container">
                                    <mat-label>Nick Name</mat-label>
                                    <input matInput formControlName="nick_name" readonly>
                                </mat-form-field>

                                <mat-form-field class="input-container">
                                    <mat-label>TID Beacon</mat-label>
                                    <input matInput formControlName="tid_beacon" readonly>
                                </mat-form-field>

                                <mat-form-field class="input-container">
                                    <mat-label>Beacon Type</mat-label>
                                    <input matInput formControlName="beacon_type" readonly>
                                </mat-form-field>

                                <mat-form-field class="input-container">
                                    <mat-label>MAC Address</mat-label>
                                    <input matInput formControlName="mac_address" readonly>
                                </mat-form-field>

                                <mat-checkbox formControlName="active" readonly>Active</mat-checkbox>
                            </div>
                        </div>
                        <div style="display:flex; flex-direction: row; gap: 200px 100px">
                            <div style="display: grid; grid-template-columns: repeat(1, 700px); gap: 0px 10px;">
                                <h2 style="background-color: rgb(2, 110, 74); color: #fdfdfd; margin-left: 10px;">
                                    &nbsp;<i style="font-size: 30px;" class="fa-solid fa-invoice"></i>&nbsp;&nbsp;Work Order
                                </h2>
                            </div>
                            <div style="display: grid; grid-template-columns: repeat(1, 700px); gap: 0px 10px;">
                                <h2 style="background-color: rgb(2, 110, 74); color: #fdfdfd; margin-left: 10px;">
                                    &nbsp;<i style="font-size: 30px;" class="fa-solid fa-truck"></i>&nbsp;&nbsp;Return Courier
                                </h2>
                            </div>
                        </div>                        
                        <div style="display:flex; flex-direction: row; gap: 200px 100px">
                            <div style="display: grid; grid-template-columns: repeat(2, 350px); gap: 0px 10px;">
                                <mat-form-field class="input-container">
                                    <mat-label>Work Order Number</mat-label>
                                    <input matInput formControlName="alternate_reference" readonly>
                                </mat-form-field>
                                <mat-form-field class="input-container">
                                    <mat-label>Work Order UUID</mat-label>
                                    <input matInput formControlName="lading_uuid" readonly>
                                </mat-form-field>
                                <button mat-raised-button style="background-color: rgb(2, 110, 74); color: #fdfdfd;" (click)="linkToLading()">
                                    &nbsp;<i class="fa-solid fa-link"></i>&nbsp;&nbsp;Link to Work Order
                                </button>
                                <div *ngIf="lading_uuid">
                                    <button mat-raised-button style="background-color: rgb(2, 110, 74); color: #fdfdfd;" (click)="viewLadingDetails()"  *ngIf="lading_uuid != ''">
                                        &nbsp;<i class="fa-solid fa-eye"></i>&nbsp;&nbsp;View Work Order
                                    </button>                                
                                </div>
                            </div>

                            <div style="display: grid; grid-template-columns: repeat(2, 350px); gap: 0px 10px;">
                                <mat-form-field class="input-container">
                                    <mat-label>Return Courier</mat-label>
                                    <input matInput formControlName="return_courier" readonly>
                                </mat-form-field>

                                <mat-form-field class="input-container">
                                    <mat-label>Tracking Number</mat-label>
                                    <input matInput formControlName="tracking_number" readonly>
                                </mat-form-field>
                                <button mat-raised-button style="background-color: rgb(2, 110, 74); color: #fdfdfd;" (click)="setCourier()">
                                    &nbsp;<i class="fa-solid fa-truck"></i>&nbsp;&nbsp;Set Return Courier
                                </button>
                            </div>                                       
                        </div>         

                    </form>

                    <br>

                    <div>
                        <h2 style="background-color: rgb(35, 24, 134); color: #fdfdfd;">
                            &nbsp;<i style="font-size: 30px;" class="fa-solid fa-earth-americas"></i>&nbsp;&nbsp;GPS Positions
                        </h2>

                        <ag-grid-angular
                            style="height: 500px; margin:20px"
                            [ngClass]="{'ag-theme-alpine-dark': dark_mode.checked, 'ag-theme-alpine-light': !dark_mode.checked}"
                            [columnDefs]="positionColumnDefs"
                            [rowData]="position_details"
                            [defaultColDef]="defaultColDef">
                        </ag-grid-angular>
                    </div>
                </mat-tab>

                <mat-tab label="MAP">
                    <div class="map-tab-wrapper">
                        <div #mapContainer id="beacon-map"></div>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>
</app-menu>